import type { LexicalIntegrations } from '@pbk-web/lexical';
import { LexicalIntegrationsProvider } from '@pbk-web/lexical';
import type { FCWithChildren } from '@pbk-web/types';
import { useMemo } from 'react';

import { useWarnOutboundLink } from '../hooks/useWarnOutboundLink';
import { imageUploadAdapter } from '../services/imageUploadAdapter';

/**
 * Wires every Lexical editor to the app: image upload/resolve and the external-link warning.
 * - One warning modal is shared by all editors, rendered here.
 */
export const LexicalIntegrationsRoot: FCWithChildren = ({ children }) => {
  const { onClick, modal } = useWarnOutboundLink();
  const value = useMemo<LexicalIntegrations>(() => ({ images: imageUploadAdapter, onLinkClick: onClick }), [onClick]);

  return (
    <LexicalIntegrationsProvider value={value}>
      {children}
      {modal}
    </LexicalIntegrationsProvider>
  );
};
